<template>
    <div >
      <div class=" ">
         <div class="row">
           <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12  col-12 nopadding">
            <div class="map"> 
            <Mapdepan/>
            </div>
        </div>
        <div class="col-xl-4  col-lg-4 col-md-6 col-sm-12 col-12 nopadding">
            <Cuaca/>
            <DataSensor/>
                        
        </div>
      </div>
    </div>
    
  </div>

</template>

<style >
/* .footer {

      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;

  } */



.card-body {
    max-height: 50vh;
}

.list-group-item {
  background-color: rgba(23,162,184, 0.562);
  color:white;
}

.nopadding {
   padding: -3 px !important;
   margin: 0 !important;
}
</style>


<script>
import Mapdepan from '@/components/Map/MapDepan.vue'
import DataSensor from '@/components/Sensor/DataSensor.vue'
import Cuaca from '@/components/Cuaca.vue'
// import SensorListDepan from '@/components/Sensor/SensorListDepan.vue'
// import LineChart from "@/components/Chart/LevelLine.vue"

export default {
   name: 'Map',
        data() {
        return {  
          backgroundColor:''

        }
      },
      components: {

        Mapdepan, 
        DataSensor,
        Cuaca
        // LineChart,
        // SensorListDepan
        // SensorData
      },

      mounted(){
        this.$store.dispatch('getApplicationPublic')
        this.$store.dispatch('getDevicePublic')
        this.$store.commit('set_Search', '')

      }
      
  
}
</script>




